import { useTrafficInfoContext } from '../traffic-info-context';
import { useState } from 'react';
import styles from './traffic-info-list.module.scss';
import { ButtonComponent } from '../../../components/controls/button/button';
import { TrafficInfoAccordion } from './traffic-info-accordion';
import { TrafficInfoLegendModal } from './traffic-info-legend-modal/traffic-info-legend-modal';

const TRAFFIC_INFO_LIST_LIMIT = 8;

export const TrafficInfoList = (): JSX.Element => {
  const trafficInfoContext = useTrafficInfoContext();
  const [showMore, setShowMore] = useState(false);
  const [legendOpen, setLegendOpen] = useState(false);

  const infoList = trafficInfoContext.filteredLines;
  const infos = showMore ? infoList : infoList.slice(0, TRAFFIC_INFO_LIST_LIMIT);
  const hasMore = infoList.length > TRAFFIC_INFO_LIST_LIMIT;

  return (
    <div className={styles.TrafficInfoList}>
      <div className={styles.TrafficInfoListLabel}>
        <span>
          <button type="button" onClick={(): void => setLegendOpen(true)}>
            Legende anzeigen
          </button>{' '}
          |
        </span>
        &nbsp;
        <span>{infoList.length} Meldungen</span>
      </div>

      <div className={styles.TrafficInfoListItems}>
        {infos.map((info, index) => (
          <TrafficInfoAccordion key={index} index={index} info={info} />
        ))}
      </div>

      {hasMore && (
        <div className={styles.TrafficInfoListMore}>
          <ButtonComponent
            small={false}
            color="primary"
            content={showMore ? 'Weniger anzeigen' : 'Alle anzeigen'}
            onClick={(): void => setShowMore(!showMore)}
          />
        </div>
      )}

      <TrafficInfoLegendModal open={legendOpen} onClose={(): void => setLegendOpen(false)} />
    </div>
  );
};
